import { Component, OnInit } from '@angular/core';
import {GlobalDataService, IsAdmin, ResetAuthToken} from "../global-data.service";
import {AuthenticationService} from "../authentication-service.service";
import {Router} from "@angular/router";
import {ViewUsersService} from "../view-users.service";

@Component({
  selector: 'app-view-users',
  templateUrl: './view-users.component.html',
  styleUrls: ['./view-users.component.css'],
  providers: [ViewUsersService]
})
export class ViewUsersComponent implements OnInit {

  private gridData: any;

  constructor(private globalDataService: GlobalDataService, private authService: AuthenticationService,
              private router: Router, private componentService: ViewUsersService) { }

  ngOnInit() {
    this.authenticate();
  }

  authenticate(): void {
    if (this.globalDataService.token == null || !IsAdmin.call(this)) {
      this.router.navigate(['/login']);
    } else {
      this.authService.Authenticate().then(this.main.bind(this))
        .catch(this.handleAuthenticationError.bind(this));
    }
  }

  handleAuthenticationError(e) {
    ResetAuthToken.call(this);
  }

  main(result): void {
    this.componentService.getData().then(this.mainSuccess.bind(this))
      .catch(this.mainFail.bind(this));
  }

  mainSuccess(result) {
    this.gridData = result;
  }

  mainFail(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    }
  }

  editHandler(event) {
    this.router.navigate(['/manage/user'], { queryParams: { id: event.dataItem.id } });
    console.log(event.dataItem);
  }

}



// WEBPACK FOOTER //
// ./src/app/view-users/view-users.component.ts